window.displayModal = (modalId) => {
	$(modalId).css('display', 'flex');
	$("body").css('overflow', 'hidden');
}

window.closeModal = (modalId) => {
	$(modalId).css('display', 'none');
	$("body").css('overflow', 'auto');
}
